import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import isPlainObject from 'lodash/isPlainObject';

export const deletePropertiesRecursively = <T extends NonNullable<unknown>>(
  obj: T,
  valuesToFilter: unknown[]
): T => {
  const result = cloneDeep(obj);

  for (const key in result) {
    const value = result[key];
    const needsDeletion = valuesToFilter.some((filterValue) =>
      isEqual(value, filterValue)
    );
    if (needsDeletion) {
      delete result[key];
    } else {
      if (value && isPlainObject(value)) {
        const processedValue = deletePropertiesRecursively(
          value as T,
          valuesToFilter
        );
        if (
          valuesToFilter.some((filterValue) =>
            isEqual(filterValue, processedValue)
          )
        ) {
          delete result[key];
        } else {
          result[key] = processedValue as T[typeof key];
        }
      }
    }
  }

  return result;
};
